import { Reveal } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { faqs } from "@/data/content";

export default function FAQ() {
  return (
    <section id="faq" className="py-14 lg:py-20 bg-pristine-surface" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-5">
        <Reveal className="text-center mb-14">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-pristine-aquadeep mb-4">FAQs</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-medium text-pristine-navy tracking-tight">
            Frequently Asked Questions
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl border border-pristine-aqua bg-white px-6 data-[state=open]:border-pristine-aquadeep transition-colors"
              >
                <AccordionTrigger className="text-left font-heading text-lg font-medium text-pristine-navy hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-pristine-navy/70 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
